import { render, staticRenderFns } from "./GoodsPublishStep1.vue?vue&type=template&id=4094cb0a&scoped=true"
import script from "./GoodsPublishStep1.vue?vue&type=script&lang=js"
export * from "./GoodsPublishStep1.vue?vue&type=script&lang=js"
import style0 from "./GoodsPublishStep1.vue?vue&type=style&index=0&id=4094cb0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4094cb0a",
  null
  
)

export default component.exports